import {Store} from "vuex";
import {ColumnFieldInterface} from "@mixins/models/ColumnFieldInterface";
import {UserProfile} from "@api/models/UserProfile";

export const getFields = (store: Store<any>, permittedFields: string[] = []) => {
    let fieldsFromOptions: ColumnFieldInterface[] = [];

    const participants = store.getters["events/selectedEventViewParam"]("participants")

    if(participants?.fields) {

        try {
            fieldsFromOptions = [...participants.fields] as ColumnFieldInterface[]
        } catch(error) {
            store.dispatch('reportException', error);
        }
    }

    if (permittedFields && permittedFields.length) {
        fieldsFromOptions = fieldsFromOptions.filter(item => permittedFields.indexOf(item.fieldName) >= 0);
    }

    return fieldsFromOptions;
}

export const prepareAdditionalFields = (fields: ColumnFieldInterface[]) => {
    return fields
        .map(({fieldName}) => UserProfile.sanitizeFieldName(fieldName))
        .filter(fieldName => {
            return !(fieldName in (new UserProfile({})))
        });
}
